<template>
  <router-link :to="go_to()" class="client_order link">
    <tr>
      <td class="w50"
          :data-label="translate('check_it')"
      >
        <input
            v-model="client_order.checked"
            type="checkbox"
            @click.stop="check"
        >
      </td>
      <td :data-label="translate('client_order.order_id')" class="w50">
        {{ client_order.id }}
      </td>
      <td :data-label="translate('client_order.client_order_spec')" class="w50" @click.prevent.stop="">
        <router-link
            v-if="client_order.client_order_spec_id" :to="'/specification/' + client_order.client_order_spec_id"
            class="link"
            :title="specification_name"
        >
          <span class="mdi mdi-briefcase"></span>
        </router-link>
      </td>
      <td :data-label="translate('client_order.date')" class="">
        {{ client_order.date }}
      </td>
      <td
          :data-label="translate('client_order.utd_number')"
          class=""
          v-html="client_order.utd_info"
      />
      <td :data-label="translate('client_order.order_form')" class="">
        {{ client_order.order_form }}
      </td>
      <td :data-label="translate('client_order.type')" class="text-left">
        {{ new_type }}
      </td>
      <td :data-label="translate('client_order.client')" class="text-left">
        {{ client_order.client_name }}
      </td>
      <td :data-label="translate('client_order.name')" class="text-left">
        <p class="limit">
          {{ client_order.name }}
        </p>
      </td>
      <td :data-label="translate('client_order.device_sku')" class="text-left w12per">
        {{ client_order.device_sku }}
      </td>
      <td :data-label="translate('client_order.device_count')" class="">
        {{ client_order.success_check_device_count}} / {{ client_order.device_count }}
      </td>
      <td :data-label="translate('client_order.equipment')" class="name">
        <p class="limit">
          {{ client_order.equipment }}
        </p>
      </td>
      <td :data-label="translate('client_order.cuxtomer_user_name')" class="name">
        {{ client_order.customer_user_name }}
      </td>
      <td :data-label="translate('client_order.status')" class="">
        <span class="badge" :style="'background-color: ' + new_status.color">
          {{ translate("client_order.statuses." + new_status.title) }}
        </span>
      </td>
    </tr>
  </router-link>
</template>
<script>

export default {
  name: 'ClientOrderListItem',
  components: {
  },
  props: ["client_order", "client_order_statuses"],
  data () {
    return {
      ts_date_options:{
        hour12: false,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }
    }
  },
  computed:{
    specification_name(){
      const specification = this.$store.getters.getClientOrderSpecs.list.find(item => {
        return item.id === this.client_order.client_order_spec_id;
      })
      return specification ? specification.name : ''
    },
    new_type(){
      let new_type = this.client_order.type !== null ? this.client_order.type : 0
      let result = this.$store.getters.getClientOrdersInfo.types.find((entry) => {
        if (entry.id === new_type){
          return entry
        }
      })
      return result ? result.descr : ""
    },
    new_status(){
      let new_status = this.client_order.status !== null ? this.client_order.status : 0

      let result = this.$store.getters.getClientOrdersInfo.statuses.find((entry) => {
        if (entry.id === new_status){
          return entry
        }
      })

      return result ? result : {title: "Error", color: "red"}
    }
  },
  methods: {
    check(){
      this.$emit('update_checked', this.client_order)
    },
    go_to() {
      return { path: '/client_order/' + this.client_order.id }
    },

  }
}
</script>

<style lang="scss" scoped>
.client_order{
  cursor: pointer;
  color: #252422;
  &:hover{
    tr{
      background-color: #eee;
    }
  }
  td{
    overflow: hidden;
    font-size: 12px;
  }
  .level{
    display: inline-block;
    width: 20px;
    height: 100%;
  }
  .has_child{
    background-color: #eee;
    font-weight: bold;
  }
  .name{
    text-align: center;
    @media (max-width: 750px) {
      text-align: right;
    }
  }
  .text-left{
    text-align: left;
  }
  .inn{
    text-align: left;
  }
  .limit{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5em;
    max-height: 3em;
    margin-bottom: 0;
    font-size: 12px;
  }
}
</style>
